import { createFileRoute } from "@tanstack/react-router";

import { SealButton, WhatsAppLink } from "@/components/site/ctas";
import { Reveal } from "@/components/site/motion";
import { CONTACT_EMAIL, getDict, href, type Lang } from "@/content/site";

export const Route = createFileRoute("/$lang/contact")({
  loader: ({ params }) => ({ lang: params.lang as Lang }),
  head: ({ loaderData }) => {
    const t = getDict(loaderData?.lang ?? "en");
    return { meta: [{ title: `${t.contact.title} · insidermark` }, { name: "description", content: t.contact.body }] };
  },
  component: Page,
});

function Page() {
  const { lang } = Route.useLoaderData();
  const t = getDict(lang);
  const c = t.contact;
  return (
    <main>
      <header className="im-page-head">
        <div className="im-wrap">
          <Reveal>
            <h1 className="im-display">{c.title}</h1>
            <p className="im-body-text mt-5">{c.body}</p>
          </Reveal>
        </div>
      </header>
      <section className="im-section im-section--tight" id="executive-desk">
        <div className="im-wrap">
          <Reveal>
            <h2 className="im-display-sm">{c.desk.title}</h2>
            <p className="im-body-text mt-4">{c.desk.body}</p>
          </Reveal>
          <dl className="im-facts mt-10">
            <div>
              <dt>{c.email}</dt>
              <dd>
                <a href={`mailto:${CONTACT_EMAIL}`}>{CONTACT_EMAIL}</a>
              </dd>
            </div>
            <div>
              <dt>{c.offices}</dt>
              <dd>{t.footer.address}</dd>
            </div>
            <div>
              <dt>{c.hours}</dt>
              <dd>{c.hoursValue}</dd>
            </div>
            <div>
              <dt>{c.languagesSpoken}</dt>
              <dd>{c.spokenList}</dd>
            </div>
          </dl>
          <div className="im-closing__ctas mt-12 justify-start">
            <SealButton to={href(lang, "/rfq")}>{t.nav.rfq}</SealButton>
            <WhatsAppLink label={c.whatsapp} />
          </div>
        </div>
      </section>
    </main>
  );
}
